import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ProductDetailsModalComponent } from '../product-details/product-details-modal/product-details-modal.component';
import { NormalizeQtyPipe } from '../shared/pipe/normalize-qty.pipe';
import { HardwareDetailsModalComponent } from './hardwares/hardware-details-modal/hardware-details-modal.component';
import { HardwareSelectorComponent } from './hardwares/hardware-selector/hardware-selector.component';
import { LocalCurrencyPipe } from './pipe/localCurrency';
import { ProductDetailsScrollableComponent } from 'app/product-details/product-details-scrollable/product-details-scrollable.component';
import { ProductZoomComponent } from './products/product-zoom/product-zoom.component';
import { SafeHtmlPipe } from './pipe/safeHtml';

@NgModule({
  // djb:should not use forRoot in shared, should be in app.module
  //imports: [
  //  CommonModule,
  //  TranslateModule.forRoot({
  //    loader: {
  //      provide: TranslateLoader,
  //      useFactory: HttpLoaderFactory,
  //      deps: [HttpClient]
  //    }
  //  }),
  //  FormsModule
  //],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule
  ],
  declarations: [
    LocalCurrencyPipe,
    NormalizeQtyPipe,
    SafeHtmlPipe,
    HardwareSelectorComponent,
    HardwareDetailsModalComponent,
    ProductDetailsModalComponent,
    ProductDetailsScrollableComponent,
    ProductZoomComponent
  ],
  exports: [
    LocalCurrencyPipe,
    NormalizeQtyPipe,
    SafeHtmlPipe,
    TranslateModule,
    HardwareSelectorComponent,
    HardwareDetailsModalComponent,
    ProductDetailsModalComponent,
    ProductDetailsScrollableComponent
  ],
  providers: [
    TranslateService,
    NormalizeQtyPipe,
    LocalCurrencyPipe,
    SafeHtmlPipe
  ],
  entryComponents: [
    ProductZoomComponent
  ]
})
export class SharedModule { }
